export default {
  color: {
    text: '#3a3d4d',
    label: '#a2a4b2',
    border: '#dbdce1',
    disabled: '#dbdce1',
    primary: '#007378',
    purple: '#bb62c8',
    error: '#e34d57',
    active: '#f0f6ff',
    gold: '#ffcd72',
    borderActive: '#007378',
    errorbg: '#fbe5e6',
    background: '#f5f5f9',
    successGreen: '#24ac8d',
    veryLightBlue: '#f0f6ff',
    veryLightRed: '#ffeff1',
    veryLightGreen: '#d7f5ee',
    veryLightPurple: '#f6ebf7',
    veryLightGold: '#fff5e3',
    white: '#fff',

    darkSkyBlue: '#4a90e2',
    
    bg_white: '#FFF',
    bg_switcher: '#8dbbbd',
  },
  fontFamily:
    '"HelveticaNeue", "Helvetica Neue","Helvetica","SF Pro Text","Arial", "sans-serif"'
};
